import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanVirtualRecurrentTransferRequestDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlanVirtualRecurrentTransferRequest extends Request<InvestmentPlanVirtualRecurrentTransferRequestDTO, string> {
  constructor(options?: RequestOptions<InvestmentPlanVirtualRecurrentTransferRequestDTO>) {
    super({
      ...options,
      method: 'PUT',
      path: `${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/transfers/recurrent/virtual`,
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  public execute(): Observable<string> {
    return super.execute().pipe(map((response: HttpResponse<string>) => response.body));
  }
}

export function createInvestmentPlanVirtualRecurrentTransfer(
  options?: RequestOptions<InvestmentPlanVirtualRecurrentTransferRequestDTO>
): InvestmentPlanVirtualRecurrentTransferRequest {
  return new InvestmentPlanVirtualRecurrentTransferRequest(options);
}
